
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from '../api'
export default {
directives: {
TransferDom
},
components: {
Tabbar,
TabbarItem,
Panel,
XHeader,
Cell,
Toast
},
mounted(){
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
post('/ruleinfo/query', {}).then(response => {

if(response.code==1){
this.ruleDatas=response.data;
let index=0;
response.data.forEach(element => {
this.ruleInfo.push({
title:element.Title,
desc:element.Content,
url: '/RuleDetail?id='+index+'&tag=E'
})
index++;
});
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
},
methods: {
onImgError (item, $event) {
console.log(item, $event)
},
addInfos(){
this.$router.push({ path: '/RuleDetail?tag=A' });
},
onClickItem(){
this.GLOBAL.currentObjs=this.ruleDatas;
}
},
data () {
return {
type: '4',
ruleInfo: [],
ruleDatas:[],
footer: {
title: "",
url: ''
},
menus: {
menu1: '新增通告'
},
showMenus: false,
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'通告查询成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
}
}
}



// WEBPACK FOOTER //
// ./src/components/ManagerModules/RuleInfo.vue